import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  partners: null,
  support: null,
  monitoring: null,
  monitoringGuide: null,
}

export const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    setFaqSupport: (state, action) => { state.support = action.payload },
    setFaqPartners: (state, action) => { state.partners = action.payload },
    setFaqMonitoring: (state, action) => { state.monitoring = action.payload },
    setFaqMonitoringGuide: (state, action) => { state.monitoringGuide = action.payload },

    resetFaq: () => initialState,
  },
})

export const {
  setFaqSupport,
  setFaqPartners,
  setFaqMonitoring,
  setFaqMonitoringGuide,

  resetFaq
} = faqSlice.actions

export default faqSlice.reducer
